const VINCULOS_IMG =
  "https://images.unsplash.com/photo-1768670231699-f5d2149d0639?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwcGVvcGxlJTIwYXV0aGVudGljJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3NjQyMTcwfDA&ixlib=rb-4.1.0&q=85";
const HORIZONTE_IMG =
  "https://images.unsplash.com/photo-1607317525484-c1bf1dd137d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxzdW5zZXQlMjBtb3VudGFpbiUyMGhvcml6b24lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc3NjQyMTg4fDA&ixlib=rb-4.1.0&q=85";

export default function DualFeed() {
  return (
    <section
      id="feed"
      data-testid="dual-feed"
      className="py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section heading */}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ El feed dual
            </p>
            <h2 className="mt-5 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
              Dos modos.<br />
              <span className="italic">Cero ruido.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-8">
            <p className="text-lg text-ink/75 leading-relaxed text-balance">
              Tú decides cuándo conectar y cuándo descubrir. Ovamx separa la intimidad de la viralidad — sin mezclas tóxicas, sin algoritmos que deciden por ti.
            </p>
          </div>
        </div>

        {/* Two modes asymmetric */}
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          {/* Modo Vínculos */}
          <article
            data-testid="mode-vinculos"
            className="col-span-12 md:col-span-7 lift"
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="w-2 h-2 rounded-full bg-coral animate-shimmer" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
                Modo · 01
              </span>
            </div>
            <div className="img-reveal rounded-2xl border hairline aspect-[4/3] md:aspect-[16/11]">
              <img
                src={VINCULOS_IMG}
                alt="Modo Vínculos — conexión humana auténtica"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-7 grid grid-cols-12 gap-4">
              <h3 className="col-span-12 sm:col-span-5 font-serif text-4xl md:text-6xl leading-none">
                Vínculos
              </h3>
              <p className="col-span-12 sm:col-span-7 text-base md:text-lg text-ink/75 leading-relaxed">
                Tu círculo real. Familia, amigos cercanos, comunidades íntimas. Cronología en orden, sin algoritmos. Lo que tus personas comparten, llega cuando lo comparten.
              </p>
            </div>
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
              <li>· orden cronológico</li>
              <li>· cero recomendaciones</li>
              <li>· círculos privados</li>
            </ul>
          </article>

          {/* Modo Horizonte */}
          <article
            data-testid="mode-horizonte"
            className="col-span-12 md:col-span-5 md:pt-24 lift"
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="w-2 h-2 rounded-full bg-ink animate-shimmer" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
                Modo · 02
              </span>
            </div>
            <div className="img-reveal rounded-2xl overflow-hidden border hairline aspect-[3/4] md:aspect-[5/7]">
              <img
                src={HORIZONTE_IMG}
                alt="Modo Horizonte — descubre el mundo"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-7">
              <h3 className="font-serif text-4xl md:text-6xl leading-none italic">
                Horizonte
              </h3>
              <p className="mt-4 text-base md:text-lg text-ink/75 leading-relaxed">
                Descubre el planeta. Creadores, ideas, oportunidades, viajes. IA cultural transparente: te decimos por qué te recomendamos algo y qué pasa cuando no lo quieres ver más.
              </p>
            </div>
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
              <li>· descubrimiento global</li>
              <li>· IA explicable</li>
              <li>· control total</li>
            </ul>
          </article>
        </div>

        {/* Toggle simulator */}
        <div className="mt-20 md:mt-28 border hairline rounded-2xl bg-white/55 backdrop-blur-sm p-6 md:p-10 grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              Cambia con un gesto
            </p>
            <p className="mt-3 font-serif text-2xl md:text-4xl leading-tight">
              Un toque. Dos mundos. Ningún algoritmo decide por ti cuándo entras o sales.
            </p>
          </div>
          <div className="col-span-12 md:col-span-5 md:justify-self-end">
            <div className="inline-flex p-1 rounded-full bg-ink text-cream">
              <span className="px-5 py-2 rounded-full bg-coral text-cream text-sm">Vínculos</span>
              <span className="px-5 py-2 text-sm text-cream/70">Horizonte</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
